import { useEffect, useState } from "react";
import Switch from "react-switch";
import { Button } from "react-bootstrap";

import { useAuth } from "../../contexts/auth";
import { update } from "../../services/api";
import Modal from "../../components/Modal";

const WaterAbstractionActions = ({ waterAbstraction, pointId, onRefresh }) => {
  const [loading, setLoading] = useState(false);
  const [hasPermission, setHasPermission] = useState(false);

  const { user } = useAuth();

  useEffect(() => {
    const hasPerm =
      user?.pumpDrivePermission !== undefined
        ? Boolean(user.pumpDrivePermission)
        : user?.role === 2 || user?.role === 3;
    setHasPermission(hasPerm);
  }, [user]);

  const status = waterAbstraction?.status ?? false;
  const pumpDrive = waterAbstraction?.pumpDrive ?? false;
  const communication = waterAbstraction?.communication ?? false;
  const alert = waterAbstraction?.alert ?? false;

  // Estado da bomba (se está ligada ou desligada)
  const isPumpOn = status;

  // Regra de habilitação do botão de disparo idêntica ao Supervisório:
  // _gbTrigger.Enabled = !alertConfig.Reading && commConfig.Reading && statusConfig.Reading == triggerConfig.Reading;
  const isTriggerEnabled =
    hasPermission && !alert && communication && status === pumpDrive;

  const handleToggleTrigger = async () => {
    if (!isTriggerEnabled) return;
    setLoading(true);
    try {
      await update(pointId, {
        columns: {
          waterAbstraction: {
            parameter: 2, // PUMP_DRIVE
            value: !isPumpOn,
          },
        },
      });
      if (onRefresh) await onRefresh();
    } catch (error) {
      console.error("Erro ao alterar acionamento da bomba:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = async () => {
    if (!hasPermission) return;
    setLoading(true);
    try {
      await update(pointId, {
        columns: {
          waterAbstraction: {
            parameter: 3, // RESET
            value: true,
          },
        },
      });
      if (onRefresh) await onRefresh();
    } catch (error) {
      console.error("Erro ao enviar reset:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleComm = async (nextChecked) => {
    if (!hasPermission) return;
    setLoading(true);
    try {
      await update(pointId, {
        columns: {
          waterAbstraction: {
            parameter: 4, // COMMUNICATION (true = Fibra, false = Rádio)
            value: nextChecked,
          },
        },
      });
      if (onRefresh) await onRefresh();
    } catch (error) {
      console.error("Erro ao alterar modo de comunicação:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Modal />}
      <hr />
      <h3 className="text-center mb-3">Captação de Água - Controles</h3>

      {/* Disparo / Acionamento da Bomba */}
      <div className="d-flex flex-column align-items-center mb-3">
        <span className="fs-5 fw-bold mb-2">
          Status da Bomba: {isPumpOn ? "LIGADA" : "DESLIGADA"}
        </span>
        <Button
          onClick={handleToggleTrigger}
          disabled={!isTriggerEnabled}
          variant={isPumpOn ? "danger" : "success"}
          className="px-4 py-2 fs-5 fw-bold shadow"
          style={{
            minWidth: "180px",
            backgroundColor: !isTriggerEnabled
              ? "#6c757d"
              : isPumpOn
                ? "#dc3545"
                : "#198754",
            borderColor: !isTriggerEnabled
              ? "#6c757d"
              : isPumpOn
                ? "#dc3545"
                : "#198754",
          }}
        >
          {isPumpOn ? "DESLIGAR" : "LIGAR"}
        </Button>
        {!communication && (
          <small className="text-warning mt-1">
            * Acionamento bloqueado no modo RÁDIO (Alterne para FIBRA)
          </small>
        )}
        {alert && (
          <small className="text-danger mt-1">
            * Acionamento bloqueado devido a Alerta ativo
          </small>
        )}
      </div>

      <div className="d-flex justify-content-around align-items-center mt-3 pt-2 border-top">
        {/* Reset de Alarmes */}
        <div className="d-flex flex-column align-items-center">
          <span className="fs-6 text-muted mb-1">Reset de Falhas</span>
          <Button
            onClick={handleReset}
            disabled={!hasPermission || !alert}
            variant={alert ? "danger" : "secondary"}
            size="sm"
            className="fw-bold px-3"
          >
            RESETAR
          </Button>
        </div>

        {/* Modo de Comunicação: Fibra vs Rádio */}
        <div className="d-flex flex-column align-items-center">
          <span className="fs-6 text-muted mb-1">
            Comunicação:{" "}
            <strong className="text-primary">
              {communication ? "FIBRA" : "RÁDIO"}
            </strong>
          </span>
          <Switch
            onChange={handleToggleComm}
            checked={communication}
            className="align-middle"
            onColor="#0d6efd"
            offColor="#ffc107"
            disabled={!hasPermission}
          />
        </div>
      </div>
    </>
  );
};

export default WaterAbstractionActions;
